import { useTRPC } from "../../../../trpc/client";
import { useQuery } from "@tanstack/react-query";
import { FiltersType } from "../types/filters.type";
import { useMemo } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";

export function useFetchSubscriptions(filters: FiltersType, cursor?: string) {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const queryFilters = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      documentNumber: filters.documentNumber?.trim() || undefined,
      subscriptionSinceRange: filters.dateRange
        ? ([
            `${filters.dateRange[0]}T00:00:00.000`,
            `${filters.dateRange[1]}T23:59:59.999`,
          ] as [string, string])
        : undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending, refetch } = useQuery({
    ...trpc.customers.listWithSubscription.queryOptions(queryFilters),
    enabled: !!merchant?.id,
    refetchInterval: 120_000,
  });

  const subscriptions = data?.customers || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = subscriptions.length || 0;

  return {
    subscriptions,
    nextCursor,
    totalItems,
    isLoading: isPending,
    refetch,
  };
}
